import { render, staticRenderFns } from "./DureeTravailConsultationsIST.vue?vue&type=template&id=0560ff5e&"
import script from "./DureeTravailConsultationsIST.vue?vue&type=script&lang=ts&"
export * from "./DureeTravailConsultationsIST.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports